export const ADMIN_EMAILS = [
    "patdevonline@gmail.com",
    "charuwan_s@hotmail.com",
    "sermyot@gmail.com",
    "thitika.f@gmail.com",
    "foxgob2@gmail.com",
    "charuwan@gmail.com",
];
